/* eslint-disable react-hooks/exhaustive-deps */
import { LikeOutlined, DislikeOutlined } from "@ant-design/icons";
import { Button, Table, Tag } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";

import CreateEditTaskModal from "./CreateEditModal";
import Hint from "./Hint/index";
import { showErrorNotification, showNotification } from "../../../../utils/notification";

const Task = ({ sectionName, sectionTasks, courseId, sectionId, ROOT_URL }) => {
  const [tasks, setTasks] = useState([]);
  const [isCreateTaskModalOpen, setIsCreateTaskModalOpen] = useState(false);
  const [isManageHintsModalOpen, setIsManageHintsModalOpen] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [taskId, setTaskId] = useState("");
  const [taskHints, setTaskHints] = useState([]);
  const [taskTitle, setTaskTitle] = useState("");
  const [currentTaskRow, setCurrentTaskRow] = useState({});

  const handleTaskDelete = (taskId) => {
    axios
      .post(`${ROOT_URL}/admin/courses/manage/task/delete`, {
        taskId,
        sectionId,
        courseId
      })
      .then((res) => {
        const { updatedTasks } = res.data;
        setTasks(updatedTasks);
        showNotification("Task deleted Successfully", "Task deleted Successfully", "success");
      })
      .catch(() => {
        showNotification("Internal Server Error", "Internal Server Error", "error");
      });
  };

  const handleCreateEditTask = (taskParams) => {
    if (
      taskParams.link.includes("codeforces.com/problemset") ||
      taskParams.link.includes("codeforces.com/contest")
    ) {
      taskParams.scorable = true;
    }
    if (initialValues?._id !== undefined) {
      axios
        .post(`${ROOT_URL}/admin/courses/manage/task/edit`, {
          taskParams,
          sectionId,
          taskId: initialValues?._id
        })
        .then((res) => {
          const { updatedTasks } = res.data;
          setTasks(updatedTasks);
          setIsCreateTaskModalOpen(false);
          showNotification("Task edited Successfully", "Task edited Successfully", "success");
        })
        .catch((err) => {
          showErrorNotification(err);
        });
    } else {
      axios
        .post(`${ROOT_URL}/admin/courses/manage/task/create`, {
          taskParams,
          sectionId,
          courseId
        })
        .then((res) => {
          const { updatedTasks } = res.data;
          setTasks(updatedTasks);
          setIsCreateTaskModalOpen(false);
          showNotification("Task created Successfully", "Task created Successfully", "success");
        })
        .catch((err) => {
          showErrorNotification(err);
        });
    }
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      ellipsis: true
    },
    {
      title: "Link",
      dataIndex: "link",
      key: "link",
      ellipsis: true
    },
    {
      title: "Platform",
      dataIndex: "category",
      key: "category"
    },
    {
      title: "Solution URL",
      dataIndex: "videoSolutionUrl",
      key: "videoSolutionUrl"
    },
    {
      title: "Day in Week",
      dataIndex: "dayNumber",
      key: "dayNumber"
    },
    {
      title: "Hint updated At",
      dataIndex: "hintUpdatedAt",
      key: "hintUpdatedAt",
      render: (hintUpdatedAt) =>
        hintUpdatedAt ? dayjs(hintUpdatedAt).format("DD MMM YYYY | HH:mm") : "--"
    },
    {
      title: "Hint Likes",
      key: "hintLikes",
      dataIndex: "totalLikes",
      render: (totalLikes) => (
        <div style={{ display: "flex" }}>
          <Tag color="green" key="like">
            <LikeOutlined />
            {totalLikes || 0}
          </Tag>
        </div>
      ),
      sorter: (a, b) => (a.totalLikes || 0) - (b.totalLikes || 0)
    },
    {
      title: "Hint Dislikes",
      key: "hintDikes",
      dataIndex: "totalDislikes",
      render: (totalDislikes) => (
        <div style={{ display: "flex" }}>
          <Tag color="red" key="dislike">
            <DislikeOutlined />
            {totalDislikes || 0}
          </Tag>
        </div>
      ),
      sorter: (a, b) => (a.totalDislikes || 0) - (b.totalDislikes || 0)
    },
    {
      title: "Tags",
      key: "tags",
      render: (row) => (
        <div>
          {row.bonus && (
            <Tag color="blue" key="bonus">
              Bonus
            </Tag>
          )}
          {row.scorable && !row.bonus && (
            <Tag color="green" key="scorable">
              Scorable
            </Tag>
          )}
          {!row.scorable && (
            <Tag color="red" key="scorable">
              Non-Scorable
            </Tag>
          )}
          {row.isCfSync && (
            <Tag color="green" key="non-scorable">
              CF Sync
            </Tag>
          )}
        </div>
      )
    },
    {
      title: "Actions",
      key: "action",
      render: (row) => (
        <div
          id="section_tasks_actions"
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "space-around",
            gap: "1em"
          }}
        >
          <Button
            type="primary"
            onClick={() => {
              setInitialValues(row);
              setIsCreateTaskModalOpen(true);
            }}
          >
            Edit
          </Button>
          <Button
            type="primary"
            danger
            onClick={() => {
              handleTaskDelete(row._id);
            }}
          >
            Delete
          </Button>
          <Button
            type="primary"
            onClick={() => {
              setTaskId(row._id);
              setTaskTitle(`${sectionName} | ${row.title}`);
              setCurrentTaskRow(row);
              setTaskHints(row.hints || []);
              setIsManageHintsModalOpen(true);
            }}
          >
            Manage Hints
          </Button>
        </div>
      )
    }
  ];

  useEffect(() => {
    setTasks(sectionTasks);
  }, []);

  return (
    <div>
      <div style={{ marginBottom: "1em" }}>
        <Button
          type="primary"
          onClick={() => {
            setInitialValues({});
            setIsCreateTaskModalOpen(true);
          }}
        >
          {" "}
          Create New Task
        </Button>
      </div>
      <div>
        <b>User Hint feedback is considered if it was marked after the hint was last updated.</b>
      </div>
      <Table
        columns={columns}
        bordered
        pagination={false}
        dataSource={tasks}
        scroll={{ x: "max-content" }}
      />
      {isCreateTaskModalOpen === true && (
        <CreateEditTaskModal
          isModalOpen={isCreateTaskModalOpen}
          setIsModalOpen={setIsCreateTaskModalOpen}
          initialValues={initialValues}
          isEdit={initialValues?._id !== undefined}
          handleCreateEdit={handleCreateEditTask}
        />
      )}
      {isManageHintsModalOpen && (
        <Hint
          isModalOpen={isManageHintsModalOpen}
          ROOT_URL={ROOT_URL}
          taskHints={taskHints}
          taskTitle={taskTitle}
          taskId={taskId}
          setTasks={setTasks}
          setIsModalOpen={setIsManageHintsModalOpen}
          currentTaskRow={currentTaskRow}
        />
      )}
    </div>
  );
};

export default Task;
